import { initializeApp } from 'firebase/app';
import { getFirestore, collection, writeBatch, doc, serverTimestamp } from 'firebase/firestore';
import { firebaseConfig } from '../config/firebase';

// Initialize Firebase for the script
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

// Default palettes (copied from functions/src/palettes.ts)
const DEFAULT_PALETTES = [
  { 
    name: 'FireForge Default', 
    colors: ['#FFD0BF', '#FFAB8C', '#FF8659', '#FF6126', '#FF4500', '#E63E00', '#BF3400', '#992900', '#731F00'], 
    defaultColor: '#FF4500', 
    usageCount: 0, 
    tags: ['default'] 
  },
  { 
    name: 'Business Casual', 
    colors: ['#1E3A8A', '#2563EB', '#3B82F6', '#60A5FA', '#93C5FD', '#BFDBFE', '#DBEAFE', '#EFF6FF', '#F8FAFC'], 
    defaultColor: '#3B82F6', 
    usageCount: 0, 
    tags: ['default'] 
  },
  { 
    name: 'Vibrant Autumn', 
    colors: ['#B91C1C', '#DC2626', '#E04D01', '#FE6B00', '#FF9500', '#FFC800', '#FFEE00', '#FFFF66', '#FFFACD'], 
    defaultColor: '#FF9500', 
    usageCount: 0, 
    tags: ['default'] 
  },
  { 
    name: 'Pastel Dreams', 
    colors: ['#FFB3E6', '#E6B3FF', '#B3D9FF', '#B3FFE6', '#D9FFB3', '#FFFFB3', '#FFE6B3', '#FFD9B3', '#FFCCB3'], 
    defaultColor: '#B3FFE6', 
    usageCount: 0, 
    tags: ['default', 'pastel'] 
  },
  { 
    name: 'Monochrome Steel', 
    colors: ['#1F2937', '#2F3640', '#475569', '#535C68', '#7F8C9B', '#9CA3AF', '#B3BEC9', '#D1D5DB', '#E5E7EB'], 
    defaultColor: '#7F8C9B', 
    usageCount: 0, 
    tags: ['default'] 
  },
  { 
    name: 'Fun Summer', 
    colors: ['#006BA6', '#0096C7', '#00B4D8', '#48CAE4', '#61E8E1', '#06FFA5', '#7FFFD4', '#FF6B9D', '#FFE66D'], 
    defaultColor: '#48CAE4', 
    usageCount: 0, 
    tags: ['default', 'summer', 'vibrant', 'tropical'] 
  },
];

export const seedDefaultPalettes = async () => {
  try {
    console.log('🌱 Starting to seed default palettes to Firestore...');
    
    const batch = writeBatch(db);
    const paletteCollection = collection(db, 'color_palettes');
    
    DEFAULT_PALETTES.forEach((palette, index) => {
      const docRef = doc(paletteCollection, `system-${index}`); // Fixed ID for system palettes
      
      batch.set(docRef, {
        ...palette,
        id: docRef.id,
        ownerId: 'system',
        organizationId: 'system',
        visibility: 'public',
        description: `System default palette: ${palette.name}`,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
      });
      
      console.log(`📋 Added to batch: ${palette.name}`);
    });
    
    await batch.commit();
    console.log('✅ Successfully seeded', DEFAULT_PALETTES.length, 'default palettes to Firestore!');
    
    return {
      success: true,
      count: DEFAULT_PALETTES.length,
      message: 'Default palettes seeded successfully'
    };
    
  } catch (error) {
    console.error('❌ Error seeding default palettes:', error);
    throw error;
  }
};

// Export for external use
export default seedDefaultPalettes;

// Note: To run this script, call the seedDefaultPalettes function from your app or console 